"use client";

import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";

const TrustpilotMini = ({ trustBoxRef }) => {
  return (
    <div
      ref={trustBoxRef}
      className="trustpilot-widget trustBox-mini"
      data-locale="en-US"
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id="64f888eb7b782062676ccb0d"
      data-style-height="115px"
      data-style-width="100%"
      data-font-family="Nunito Sans"
      data-testid="trustpilot-widget"
    >
      <a
        href="https://www.trustpilot.com/review/qrcreator.com"
        target="_blank"
        rel="noopener"
      ></a>
    </div>
  );
};

export const Trustpilot = () => {
  const ref = useRef(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    let retryCount = 0;
    const maxRetries = 9;
    const retryDelay = 500;

    const loadTrustpilotWidget = () => {
      if (!ref.current) {
        return false;
      }

      if (typeof window.Trustpilot?.loadFromElement !== "function") {
        if (retryCount < maxRetries) {
          retryCount++;
          timeoutId = setTimeout(loadTrustpilotWidget, retryDelay);
        } else {
        }
        return false;
      }

      try {
        window.Trustpilot.loadFromElement(ref.current, true);
        setIsInitialized(true);
        return true;
      } catch {
        return false;
      }
    };

    loadTrustpilotWidget();

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  return (
    <div
      style={{ visibility: isInitialized ? "visible" : "hidden" }}
      className="trustpilot__wrapper"
    >
      <TrustpilotMini trustBoxRef={ref} />
    </div>
  );
};
